/*
==========================================
STAMP PINCH ZOOM  v1.1.0
文件: assets/stamp-pinch-zoom.js

v1.1.0 修复：
- writeSliderPct / writeAddressPct 加 rAF 节流
  touchmove 每帧最多触发一次 updatePhotoCenterSize/setIllusScale
  修复：双指缩放卡顿不流畅

v1.0.0：

【为什么要这个文件 — 诊断报告】

stamp-ui.js 的 _addPinchZoomSupport() 存在以下 BUG，
导致手机端双指缩放完全失效：

BUG 1（最关键）：MO 监听目标写错了
  MO 监听的是 '.prod-mobile-preview-bottom'
  但用户实际操作的 prodMobileCanvasBottom 在 '.prod-mobile-preview-top' 里
  （名字是反的：顶部预览用的 canvas 叫 Bottom，底部用的叫 Top）
  → 图片上传后 MO 触发不到，attachAll() 不被调用，pinch 从未绑定

BUG 2：事件绑在子元素上，容易漏绑
  attachToArea() 找 .prod-illustration-left / .prod-photo-preview-area 等具体子元素
  时机稍有差错（上传照片后 DOM 结构变化）就可能漏掉
  产品9的做法更可靠：直接把 touchstart/touchmove 绑在最外层 canvas 上

BUG 3：image-left 照片上传后没有重新扫描手机端
  confirmCrop() 完成后调用 window._attachPinchZoomToPhotos()
  但此时 MO 已经失效（BUG 1），新增的 .prod-illustration-left img 未被绑定

【本模块的解决方案】

产品9做法（最可靠）：把 touchstart/touchmove 直接绑在预览容器上，
不依赖查找子元素，容器不变则监听永远有效。

绑定目标（容器级，不是子元素）：
  手机端主交互区  → .prod-mobile-preview-top（包含 prodMobileCanvasBottom）
  手机端次级预览  → .prod-mobile-preview-canvas--top（包含 prodMobileCanvasTop）
  桌面端主预览    → .prod-stamp-canvas-wrapper（包含 prodStampCanvas）
  产品9专属      → #prodAddressCanvas（直接 canvas）

触发条件：双指落在预览容器内，不管具体落点
缩放对象：读写 prodPhotoSizeSlider（DOM 布局产品）
          或调用 StampAddressComposer.setIllusScale()（产品9）

【加载顺序（stamp-customizer.liquid 最后一行）】

  stamp-canvas-text-renderer.js
  stamp-core.js
  stamp-ui.js
  stamp-image-processor.js
  stamp-body-composer.js
  stamp-address-composer.js   ← 仅 address-label 布局
  stamp-customizer.js
  stamp-patch.js
  stamp-pinch-zoom.js         ← 最后，覆盖所有产品
==========================================
*/

(function () {
  'use strict';

  /* ─── 工具 ─── */
  function getConfig() {
    try { return JSON.parse(document.getElementById('prodStampConfig').textContent || '{}'); }
    catch (e) { return {}; }
  }

  function getTouchDist(touches) {
    var dx = touches[0].clientX - touches[1].clientX;
    var dy = touches[0].clientY - touches[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  /* ─── 读写 prodPhotoSizeSlider（DOM 布局产品通用）─── */
  function readSliderPct() {
    var sl = document.getElementById('prodPhotoSizeSliderNew')
          || document.getElementById('prodPhotoSizeSlider');
    return sl ? parseInt(sl.value, 10) : 70;
  }

  /* ★ v1.1.0 修复：用 rAF 节流，避免 touchmove 每帧多次触发 updatePhotoCenterSize 导致卡顿 */
  var _rafPending = false;
  var _pendingPct = null;

  function writeSliderPct(pct) {
    var sl    = document.getElementById('prodPhotoSizeSliderNew')
             || document.getElementById('prodPhotoSizeSlider');
    var origSl = document.getElementById('prodPhotoSizeSlider');
    if (!sl) return;

    pct = Math.max(+(sl.min) || 20, Math.min(+(sl.max) || 150, pct));

    /* 先同步更新 UI（不等 rAF，视觉立即响应）*/
    sl.value = pct;
    var fill = ((pct - (+(sl.min) || 20)) / ((+(sl.max) || 150) - (+(sl.min) || 20)) * 100).toFixed(1) + '%';
    sl.style.setProperty('--fill', fill);
    ['prodPhotoSizeValNew', 'prodPhotoSizeVal'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.textContent = pct + '%';
    });

    /* DOM 渲染（updatePhotoCenterSize）用 rAF 节流：每帧最多执行一次 */
    _pendingPct = { pct: pct, sl: sl, origSl: origSl };
    if (!_rafPending) {
      _rafPending = true;
      requestAnimationFrame(function () {
        _rafPending = false;
        if (!_pendingPct) return;
        var p = _pendingPct; _pendingPct = null;
        if (p.origSl && p.origSl !== p.sl) {
          p.origSl.value = p.pct;
          p.origSl.dispatchEvent(new Event('input'));
        } else {
          p.sl.dispatchEvent(new Event('input'));
        }
      });
    }
  }

  /* ─── 产品9（address-label）缩放 ─── */
  function readAddressPct() {
    var sl = document.getElementById('prodAlIllusSizeSlider');
    return sl ? parseInt(sl.value, 10) : 100;
  }

  var _rafAddrPending = false;
  var _pendingAddrPct = null;

  function writeAddressPct(pct) {
    pct = Math.max(20, Math.min(250, pct));
    /* 先更新 slider UI */
    var sl = document.getElementById('prodAlIllusSizeSlider');
    if (sl) {
      sl.value = pct;
      var fill = ((pct - 20) / (250 - 20) * 100).toFixed(1) + '%';
      sl.style.setProperty('--fill', fill);
      var valEl = document.getElementById('prodAlIllusSizeVal');
      if (valEl) valEl.textContent = pct + '%';
    }
    /* rAF 节流 setIllusScale（canvas 重绘较重）*/
    _pendingAddrPct = pct;
    if (!_rafAddrPending) {
      _rafAddrPending = true;
      requestAnimationFrame(function () {
        _rafAddrPending = false;
        if (_pendingAddrPct === null) return;
        var p = _pendingAddrPct; _pendingAddrPct = null;
        if (window.StampAddressComposer && typeof window.StampAddressComposer.setIllusScale === 'function') {
          window.StampAddressComposer.setIllusScale(p);
        }
      });
    }
  }

  /* ─────────────────────────────────────────────────────────
     核心：给一个「预览容器」绑定双指缩放
     产品9做法：事件绑在容器上，不查找子元素
  ───────────────────────────────────────────────────────── */
  function bindPinchOnContainer(container, readPct, writePct) {
    if (!container || container._szPinchBound) return;
    container._szPinchBound = true;

    var active    = false;
    var startDist = 0;
    var startPct  = 70;

    container.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 2) return;
      active    = true;
      startDist = getTouchDist(e.touches);
      startPct  = readPct();
      e.preventDefault();   /* 阻止页面缩放 */
    }, { passive: false });

    container.addEventListener('touchmove', function (e) {
      if (!active || e.touches.length !== 2) return;
      e.preventDefault();
      var ratio  = getTouchDist(e.touches) / startDist;
      var newPct = Math.round(startPct * ratio);
      writePct(newPct);
    }, { passive: false });

    container.addEventListener('touchend', function (e) {
      if (e.touches.length < 2) active = false;
    });

    container.addEventListener('touchcancel', function () {
      active = false;
    });
  }

  /* ─────────────────────────────────────────────────────────
     主入口：根据布局找到所有预览容器并绑定 pinch
  ───────────────────────────────────────────────────────── */
  function attachAll() {
    var config = getConfig();
    var layout = config.layout || '';

    /* ── 产品9：address-label ── */
    if (layout === 'address-label') {
      /* 直接绑在 prodAddressCanvas 上（和产品9内部完全一致的做法） */
      var addrCanvas = document.getElementById('prodAddressCanvas');
      if (addrCanvas) bindPinchOnContainer(addrCanvas, readAddressPct, writeAddressPct);
      return;
    }

    /* ── text-only：没有图片，不需要缩放 ── */
    if (layout === 'text-only') return;

    /* ── body-template：暂不处理（composer 有自己的逻辑）── */
    if (layout === 'body-template') return;

    /* ── 其余所有 DOM 布局产品（image-left / image-top / image-center / photo-upload / curved-text）── */
    /* 绑在「预览容器」上，不找子元素 */
    var containers = [
      /* 手机端主交互预览（prodMobileCanvasBottom 的父容器） */
      document.querySelector('.prod-mobile-preview-top .prod-mobile-preview-canvas'),
      /* 手机端底部只读预览（prodMobileCanvasTop 的父容器） */
      document.querySelector('.prod-mobile-preview-canvas--top'),
      /* 桌面端主预览（prodStampCanvas 的父容器） */
      document.querySelector('.prod-preview-section .prod-stamp-canvas-wrapper'),
      /* 兜底：直接用 stamp canvas 本身 */
      document.getElementById('prodStampCanvas'),
      document.getElementById('prodMobileCanvasBottom'),
    ];

    containers.forEach(function (c) {
      if (c) bindPinchOnContainer(c, readSliderPct, writeSliderPct);
    });
  }

  /* ─────────────────────────────────────────────────────────
     初始化：等所有 JS 完成后再绑定
     defer 脚本保证顺序执行，但 stamp-patch.js 里有 600ms 的 setTimeout
     所以这里稍等 700ms 确保 getAllCanvases patch 已生效
  ───────────────────────────────────────────────────────── */
  function init() {
    setTimeout(function () {
      attachAll();

      /* 照片上传完成后再绑一次（此时 img 元素已注入，容器已存在） */
      var origFn = window._attachPinchZoomToPhotos;
      window._attachPinchZoomToPhotos = function () {
        if (typeof origFn === 'function') origFn();
        attachAll();
      };
    }, 700);

    /* 延迟兜底（字体/图片加载慢的情况） */
    setTimeout(attachAll, 1500);
    setTimeout(attachAll, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* 对外暴露（调试用） */
  window.StampPinchZoom = { attachAll: attachAll };

})();